import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const ExecutiveSummary = ({
  t,
  company,
  company_shareholders = [],
  financial_summary,
  statementYear,
  currencyLocal,
  money,
  convertApiDate
}) => {
  const globalUltimateParent =
    company?.ultimateShareholderData?.globalUltimate?.name ||
    company_shareholders.find((x) => x?.companyType === "global")?.name ||
    "-";
  const annualSalesText = (() => {
    const local = money(financial_summary?.annualSales, currencyLocal);
    const usd = money(financial_summary?.annualSalesUs, "USD");

    if (local === "-" && usd === "-") return "-";
    if (local !== "-" && usd !== "-") return `${local} (approx. ${usd} US)`;
    return local !== "-" ? local : usd;
  })();

  const executiveSummaryData = [
    {
      title: "Company Name",
      details: company?.primaryName ?? "-",
    },
    {
      title: "Primary Line of Business",
      details: company?.lineOfBusiness ?? "-",
    },
    {
      title: "Establishment Location",
      details:
        [
          company?.establishmentAddressCity,
          company?.establishmentAddressRegion,
          company?.establishmentAddressCountry,
        ]
          .filter(Boolean)
          .join(", ") || "-",
    },
    {
      title: "Start Year",
      details: financial_summary?.startYear || "-",
    },
    {
      title: "Global Ultimate Parent",
      details: globalUltimateParent,
    },
    {
      title: `Annual Sales${statementYear ? ` (${statementYear})` : ""}`,
      details: annualSalesText,
    },

    {
      title: "Total Employees",
      details: financial_summary?.employeesTotal ?? "-",
    },
    {
      title: "Report Date",
      details: financial_summary?.reportDate
        ? convertApiDate(financial_summary.reportDate)
        : "-",
    },
  ];

  return (
    <View style={styles.section}>
      <Text style={styles.sectionSeparator}>
        {`${t("1.")} ${t("Executive Summary")}`}
      </Text>

      <View style={styles.table} wrap={false}>
        <View style={styles.tableRow} wrap={false} minPresenceAhead={24}>
          <View style={styles.tableColHeader}>
            <Text
              style={{
                ...styles.tableCell,
                ...styles.fontBold,
              }}
            >
              {t("Title ")}
            </Text>
          </View>
          <View
            style={{
              ...styles.tableColHeader,
              ...styles.borderRightNone,
            }}
          >
            <Text
              style={{
                ...styles.tableCell,
                ...styles.fontBold,
              }}
            >
              {t("Details")}
            </Text>
          </View>
        </View>

        {executiveSummaryData.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === executiveSummaryData.length - 1
              ? styles.tableLastRow
              : {}),
          };

          return (
            <View style={rowStyle} key={i} wrap={false}>
              {/* Title column */}
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              {/* Details column */}
              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default withNamespaces()(ExecutiveSummary);
